// export const SPORT_URL = isProductionEnv
//   ? 'https://monixbet.sptpub.com/bt-renderer.min.js'
//   : 'https://ui.invisiblesport.com/bt-renderer.min.js';
export const SPORT_URL = 'https://ui.invisiblesport.com/bt-renderer.min.js';
